module.exports = __webpack_public_path__ + "img/2941391-49-5.4af292dc.png";